export default {
  namespaced: true,
  state: {
    brand: '',
    categories: '',
    combinations: '',
    description: '',
    name: '',
    user_contribution: '',
    savedSelectedCategory: {},
    newBrand: '',
    isFormHasBeenFilled: false,
  },
  mutations: {
    setForm(state, value) {
      state.isFormHasBeenFilled = value;
    },
    setNewBrand(state, value) {
      state.newBrand = value;
    },
    setBrand(state, value) {
      state.brand = value;
    },
    setCategories(state, value) {
      state.categories = value;
    },
    setSavedSelectedCategory(state, value) {
      state.savedSelectedCategory = value;
    },
  },
  actions: {
    addBrand({ commit }, payload) {
      return this._vm.$MS_SOCO_PUBLIC_API_URL.post('/brands', payload);
    },
    updateBrand({ commit }, payload) {
      return this._vm.$MS_SOCO_PUBLIC_API_URL.put('/brands', payload);
    },
  },
};
